import {ShopifyAnalyticsPayload} from '@shopify/hydrogen';
import type {
  Product,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';

import ProductGallery from '~/components/product/Gallery';
import ProductWidget from '~/components/product/Widget';
import type {SanityProductPage} from '~/lib/sanity';
import ProductGalleryDetail from './GalleryDetail';

type Props = {
  sanityProduct: SanityProductPage;
  storefrontProduct: Product;
  selectedVariant: ProductVariant;
  analytics: ShopifyAnalyticsPayload;
};

export default function ProductDetails({
  sanityProduct,
  storefrontProduct,
  selectedVariant,
  analytics,
}: Props) {
  return (
    <>
      {/* Gallery */}
      <div
        className={clsx('mt-12 pl-0 pt-5', 'md:mt-25 md:flex md:pl-8 md:pt-5')}
      >
        <div
          className={clsx(
            'h-full w-full',
            'overflow-hidden md:h-full md:w-[50vw]',
          )}
        >
          <ProductGalleryDetail
            storefrontProduct={storefrontProduct}
            selectedVariant={selectedVariant}
          />
        </div>

        {/* Widget (mobile) */}
        {/* Widget (desktop) */}
        <div className={clsx('w-full', 'md:w-[50vw]')}>
          <div className="h-full w-full">
            <div className={clsx('h-full p-4', 'md:p-10')}>
              <ProductWidget
                sanityProduct={sanityProduct}
                storefrontProduct={storefrontProduct}
                selectedVariant={selectedVariant}
                analytics={analytics}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
